import { call, put, takeEvery } from "redux-saga/effects";
import CutoffLunchMenuService from "../../../services/admin/cutoffLunchMenu";
import { cutoffLunchMenuList, cutoffScheduleList } from "../../actionCreators/admin/cutoffLunchMenu";
import {
  GET_CUTOFF_LUNCH_MENU_WATCHER, SAVE_CUTOFF_LUNCH_MENU_WATCHER, DELETE_CUTOFF_LUNCH_MENU_WATCHER,
  GET_CUTOFF_SCHEDULE_WATCHER, SAVE_CUTOFF_SCHEDULE_WATCHER, TOGGLE_CUTOFF_SCHEDULE_WATCHER,
  GENERATE_CUTOFF_SCHEDULE_WATCHER, DELETE_CUTOFF_SCHEDULE_WATCHER
} from "../../actionTypes/admin";
import { updateFalseLoader, updateOpenLoader } from "../../actionCreators/spinner";
import { updateAlert } from "../../actionCreators/alert";
import { errorMessage } from "../../../utils/errorMessage";


function* getCutoffLunchMenuEffect(action) {
  try {
    yield put(updateOpenLoader());
    let { data } = yield call(CutoffLunchMenuService.getAll, action.payload);

    yield put(cutoffLunchMenuList(data.recordset));
    yield put(updateFalseLoader());
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(errorMessage(e, 'Something Went Wrong'), 'error'));
  }
}

function* saveCutoffLunchMenuEffect(action) {
  try {
    yield put(updateOpenLoader());
    let { data } = yield call(CutoffLunchMenuService.save, action.payload);

    if (action.setOpen) action.setOpen(false)
    yield put(cutoffLunchMenuList(data.recordset));
    yield put(updateFalseLoader());
    yield put(updateAlert(action.payload.ACTION === 'UPDATE' ? 'Updated Successfully' : 'Created Successfully', 'success'));
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(e.response?.data?.message || 'Something Went Wrong', 'error'));
  }
}

function* deleteCutoffLunchMenuEffect(action) {
  try {
    yield put(updateOpenLoader());
    let { data } = yield call(CutoffLunchMenuService.delete, action.id);

    yield put(cutoffLunchMenuList(data.recordset));
    yield put(updateFalseLoader());
    yield put(updateAlert('Deleted Successfully', 'success'));
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(e.response?.data?.message || 'Something Went Wrong', 'error'));
  }
}

/*
  Schedules. Every change answers with { schedules, cutoffs }: generating (or
  saving an automatic schedule due today) also adds to today's cutoff list.
*/
function* getCutoffScheduleEffect() {
  try {
    yield put(updateOpenLoader());
    let { data } = yield call(CutoffLunchMenuService.getSchedules);

    yield put(cutoffScheduleList(data.recordset));
    yield put(updateFalseLoader());
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(errorMessage(e, 'Something Went Wrong'), 'error'));
  }
}

function* scheduleChange(request, successMessage, setOpen) {
  try {
    yield put(updateOpenLoader());
    let { data } = yield request;

    if (setOpen) setOpen(false)
    yield put(cutoffScheduleList(data.schedules));
    yield put(cutoffLunchMenuList(data.cutoffs));
    yield put(updateFalseLoader());
    yield put(updateAlert(typeof successMessage === 'function' ? successMessage(data) : successMessage, 'success'));
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(e.response?.data?.message || 'Something Went Wrong', 'error'));
  }
}

function* saveCutoffScheduleEffect(action) {
  const verb = action.payload.ACTION === 'UPDATE' ? 'Updated' : 'Created'
  yield* scheduleChange(
    call(CutoffLunchMenuService.saveSchedule, action.payload),
    (data) => data.generatedToday ? `${verb} Successfully. Today's cutoff is live` : `${verb} Successfully`,
    action.setOpen
  )
}

function* toggleCutoffScheduleEffect(action) {
  yield* scheduleChange(call(CutoffLunchMenuService.toggleSchedule, action.id, action.isActive), action.isActive ? 'Schedule resumed' : 'Schedule paused')
}

function* generateCutoffScheduleEffect(action) {
  yield* scheduleChange(call(CutoffLunchMenuService.generateSchedule, action.id), "Today's cutoff created")
}

function* deleteCutoffScheduleEffect(action) {
  yield* scheduleChange(call(CutoffLunchMenuService.deleteSchedule, action.id), 'Deleted Successfully')
}

//saga
export const CutoffLunchMenuSaga = [
  takeEvery(GET_CUTOFF_LUNCH_MENU_WATCHER, getCutoffLunchMenuEffect),
  takeEvery(SAVE_CUTOFF_LUNCH_MENU_WATCHER, saveCutoffLunchMenuEffect),
  takeEvery(DELETE_CUTOFF_LUNCH_MENU_WATCHER, deleteCutoffLunchMenuEffect),
  takeEvery(GET_CUTOFF_SCHEDULE_WATCHER, getCutoffScheduleEffect),
  takeEvery(SAVE_CUTOFF_SCHEDULE_WATCHER, saveCutoffScheduleEffect),
  takeEvery(TOGGLE_CUTOFF_SCHEDULE_WATCHER, toggleCutoffScheduleEffect),
  takeEvery(GENERATE_CUTOFF_SCHEDULE_WATCHER, generateCutoffScheduleEffect),
  takeEvery(DELETE_CUTOFF_SCHEDULE_WATCHER, deleteCutoffScheduleEffect)
]
